import type { PropsWithChildren } from "react";

type OverlayShellProps = { label: string };

export const OverlayShell = ({ label, children }: PropsWithChildren<OverlayShellProps>) => (
	<dialog
		open
		aria-label={label}
		className="fixed inset-0 z-[9999] m-0 flex h-full max-h-none w-full max-w-none flex-col items-center justify-center border-0 bg-white px-6 py-0"
	>
		<div className="flex w-full max-w-sm flex-col items-center gap-4 text-center sm:max-w-xl">{children}</div>
	</dialog>
);
